import moment from 'moment';

const spelledOutMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const spelledOutDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const buildRotatingDigests = () => {
  const date = new Date();
  const year = date.getYear() + 1900;
  const currentMonth = date.getMonth();
  const result = {};

  for (let i = 0; i < 12; i++) {
    const month = (currentMonth + i) % 12;
    const monthYear = currentMonth + i > 11 ? year + 1 : year;
    const digestMonth = {
      index: i,
      month: spelledOutMonths[month],
      year: monthYear,
      collapsed: i !== 0,
      digests: {},
      digestCount: 0,
      tileCount: 0,
      id: month,
    };
    const digestKey = moment()
      .year(monthYear)
      .month(month)
      .format('YYYY-MM');

    result[digestKey] = digestMonth;
  }

  return result;
};

const buildRotatingDigestBucketMonths = () => {
  const date = new Date();
  const year = date.getYear() + 1900;
  const currentMonth = date.getMonth();
  const result = [];
  for (let i = 0; i < 12; i++) {
    const month = (currentMonth + i) % 12;
    result.push(
      `${spelledOutMonths[month]} ${currentMonth + i > 11 ? year + 1 : year}`,
    );
  }
  return result;
};

const parsePlanned = planned => {
  const monthIndex = parseInt(planned.split('-')[1], 10) - 1;
  const day = parseInt(planned.split('-')[2], 10);
  return `${spelledOutMonths[monthIndex]} ${day}`;
};

const isPastOrLastDay = planned => {
  const digestMonth = parseInt(planned.split('-')[1], 10) - 1;
  const digestDay = parseInt(planned.split('-')[2], 10);
  const date = new Date();
  const today = date.getDate();
  const lastDay = date.getDaysInMonth();
  return (
    (today > digestDay || today === lastDay) && date.getMonth() === digestMonth
  );
};

const DateMaker = {
  spelledOutMonths,
  buildRotatingDigestBucketMonths,
  parsePlanned,
  isPastOrLastDay,
  spelledOutDays,
};

DateMaker.splitDate = rawDate => {
  const split = rawDate.split('T')[0].split('-');
  return {
    spelledOutDays: spelledOutDays[0],
    spelledOutMonth: spelledOutMonths[split[1] - 1],
    monthNumber: split[1],
    day: split[2],
    fullYear: split[0],
  };
};

export default DateMaker;
